import { action, observable, computed, set, makeObservable } from 'mobx';
import { apiService } from '../../services/api.service';
import { history } from 'fn-common-ui';
import { modalsStore } from '../modals.store';

export default class NewAppNamePlatformStore {

	constructor(master) {
		makeObservable(this);
		this.newAppMasterStore = master;
		this.createAlert = master.createAlert;
		this.resetSubmissionProcess = master.resetSubmissionProcess.bind(master);
	}

	apiFail = (error) => {
		throw error;
	};

	// ACTIONS
	@action updateValue(id, value) {
		this.newAppMasterStore.newAppData[id] = value;
	}

	@action checkForNewAppData() {
		if(!this.newAppMasterStore.newAppData.saveId) {
			set(this.newAppMasterStore.newAppData, {
				appName: '',
				platform: ''
			});
		}
	}

	@action deleteDraft () {
		const appData = this.newAppMasterStore.newAppData; //must store current app before service call
		const success = () => {
			modalsStore.toggleModal('deleteDraft');
			this.newAppMasterStore.createAlert({
				title: 'Your draft has been deleted.',
				message: `<strong>${appData.appName} ${(appData.version) ? `v${appData.version}` : ''} ${appData.platform ? `for ${appData.platform}` : ''}</strong> will not be reviewed by the FirstNet team. This does not affect any previously approved versions of the app.`,
				type: 'info'
			}, '/my-apps');

			//Save latest to the clone since it reflects what's on the server
			this.newAppMasterStore.cloneNewAppData();
			this.resetSubmissionProcess();

			history.push('/my-apps');
		};
		return apiService.deleteDraft(this.newAppMasterStore.newAppData.saveId).then(success, this.apiFail);
	}

	@action discardAndGoBack() {
		this.newAppMasterStore.clearNewAppData();
		history.back();
	}

	@action discardChangesAndClose() {
		//return to VIEW mode for current app
		//TODO add a check for isDirty before kicking off this api call
		this.newAppMasterStore.loadDraft(this.newAppMasterStore.newAppData.saveId);
	}

	@action editSavedNameAndPlatform() {
		this.newAppMasterStore.masterStateProps.namePlatformIsEditable = true;
	}

	@computed get isValid() {
		let basicDataIsValid = this.newAppMasterStore.newAppData.appName
			&& this.newAppMasterStore.newAppData.platform
			&& this.newAppMasterStore.newAppData.listingType;

		let extraDataIsValid = this.newAppMasterStore.newAppData.listingType !== 'CROSSLISTED'
			|| (!this.storeLinkBreaksFormatCriterion
			&& this.newAppMasterStore.newAppData.storeLink
			&& this.newAppMasterStore.newAppData.urlType
			&& this.newAppMasterStore.newAppData.storeVersion);

		return Boolean(basicDataIsValid && extraDataIsValid);
	}

	@observable storeLinkBreaksFormatCriterion = false;
}
